import React, {Component} from 'react';
import { bindActionCreators } from 'redux'
import {connect} from 'react-redux';
import {Form, Control, Errors} from "react-redux-form";
import { register, getCountries } from '../reducers/auth'
import emails from '../blocked-emails'

const isValidEmail = (val) => {
	console.log(val && emails.indexOf(val.split('@').pop()) === -1);

	return val && emails.indexOf(val.split('@').pop()) === -1
}

function mapStateToProps(state) {
	return {
		auth: state.auth
	};
}

const mapDispatchToProps = dispatch => bindActionCreators({
	register,
	getCountries
}, dispatch)

class Register extends Component {
	componentDidMount() {
		this.props.getCountries();
	}

	render() {
		return (
			<Form model={'auth'} onSubmit={this.props.register}>
				{this.props.auth.error && <p className={"error"}>{this.props.auth.error}</p>}

				<div className="position-relative input-effect">
					<Control.text model={'.user.FirstName'} className={!!this.props.auth.user.FirstName ? 'effect has-content' : 'effect'} type="text" />
						<label>First Name</label>
				</div>

				<div className="position-relative input-effect">
					<Control.text model={'.user.LastName'} className={!!this.props.auth.user.LastName ? 'effect has-content' : 'effect'} type="text" />
						<label>Last Name</label>
				</div>

				<div className="position-relative input-effect">
					<Control.text model={'.user.Username'} className={!!this.props.auth.user.Username ? 'effect has-content' : 'effect'} type="text" />
						<label>Username</label>
				</div>

				<div className="position-relative input-effect">
					<Control.text model={'.user.Password'} className={!!this.props.auth.user.Password ? 'effect has-content' : 'effect'} type="password" />
					<label>Password</label>
				</div>

				<div className="position-relative input-effect">
					<Control.text model={'.user.JobTitle'} className={!!this.props.auth.user.JobTitle ? 'effect has-content' : 'effect'} type="text" />
						<label>Job Title</label>
				</div>

				<div className="position-relative input-effect">
					<Control.text model={'.user.Company'} className={!!this.props.auth.user.Company ? 'effect has-content' : 'effect'} type="text" />
						<label>Company</label>
				</div>

				<div className="position-relative input-effect">
					<Control.select model={'.user.Skills'} className={!!this.props.auth.user.Skills ? 'effect select has-content' : 'effect select'} placeholder="Choose your skills" required>
						<option value="" />
						<option value="Incident Response">Incident Response</option>
						<option value="Forensic Investigations">Forensic Investigations</option>
						<option value="Hacking">Hacking</option>
						<option value="Pentesting">Pentesting</option>
					</Control.select>

					<label>Choose Your Skills</label>
				</div>

				<div className="position-relative input-effect">
					<Control.text validators={{
						validEmail: (val) => isValidEmail(val)
					}} model={'.user.EmailAddress'} className={!!this.props.auth.user.EmailAddress ? 'effect has-content' : 'effect'} type="email" />
						<label>Email</label>

					<Errors
						className={'error-message'}
						model=".user.EmailAddress"
						messages={{
							validEmail: 'Please provide a business address.'
						}}
					/>
				</div>

				<div className="position-relative input-effect">
					<Control.text model={'.user.Telephone'} className={!!this.props.auth.user.Telephone ? 'effect has-content' : 'effect'} type="tel" />
						<label>Phone</label>
				</div>

				<div className="position-relative input-effect">
					<Control.select model={'.user.CountryId'} className={!!this.props.auth.user.CountryId ? 'effect select has-content' : 'effect select'} placeholder="Country" required>
						<option value="" />
						{this.props.auth.countries.map((item, key) => {
							return (
								<option key={key} value={item.Id}>{item.Name}</option>
							)
						})}
					</Control.select>

					<label>Country</label>
				</div>

				<input type="submit" className="submit bold btn-hover" value="Start the Challenge" />
			</Form>
		);
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Register);